import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-gray-900 rounded-t-[32px] md:rounded-t-[40px] mx-2 md:mx-4 mt-20">
      <div className="px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-16">
          <div className="lg:col-span-1">
            <h3 className="text-2xl md:text-3xl font-light text-white mb-4">
              {t('footer.brandName')}
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-6 max-w-sm">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-600 transition-colors">
                <i className="ri-instagram-line text-white text-sm"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-600 transition-colors">
                <i className="ri-facebook-line text-white text-sm"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-600 transition-colors">
                <i className="ri-youtube-line text-white text-sm"></i>
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-600 transition-colors">
                <i className="ri-tiktok-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer.navigation')}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors underline underline-offset-4">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/artistas" className="text-sm text-gray-400 hover:text-white transition-colors underline underline-offset-4">
                  {t('nav.artists')}
                </Link>
              </li>
              <li>
                <Link to="/registro" className="text-sm text-gray-400 hover:text-white transition-colors underline underline-offset-4">
                  {t('nav.register')}
                </Link>
              </li>
              <li>
                <Link to="/sobre-nosotros" className="text-sm text-gray-400 hover:text-white transition-colors underline underline-offset-4">
                  {t('nav.about')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">
                <i className="ri-phone-line mr-2 text-amber-600"></i>
                {t('footer.phone')}
              </li>
              <li className="text-sm text-gray-400">
                <i className="ri-mail-line mr-2 text-amber-600"></i>
                {t('footer.email')}
              </li>
              <li className="text-sm text-gray-400 leading-relaxed">
                <i className="ri-map-pin-line mr-2 text-amber-600"></i>
                {t('footer.location')}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors underline underline-offset-4">
              {t('footer.privacyPolicy')}
            </a>
            <a href="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors underline underline-offset-4">
              {t('footer.termsOfService')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}